import { api } from '@pwa/lib/hono-client';
import { queryOptions, skipToken } from '@tanstack/react-query';

export const orgQueries = {
	all: () => ['org'] as const,

	list: () =>
		queryOptions({
			queryKey: [...orgQueries.all(), 'list'],
			queryFn: async () => {
				const res = await api.orgs.$get();
				if (!res.ok) throw new Error('Failed to fetch organizations');
				return await res.json();
			},
			staleTime: 1000 * 60,
		}),

	detail: (organizationId: string) =>
		queryOptions({
			queryKey: [...orgQueries.all(), organizationId],
			queryFn: async () => {
				const res = await api.orgs[':orgId'].$get({
					param: { orgId: organizationId },
				});
				if (!res.ok) throw new Error('Failed to fetch organization');
				return await res.json();
			},
			staleTime: 1000 * 60,
		}),

	members: (organizationId?: string | null) =>
		queryOptions({
			queryKey: [...orgQueries.all(), organizationId, 'members'],
			queryFn: organizationId
				? async () => {
						const res = await api.orgs[':orgId'].members.$get({
							param: { orgId: organizationId },
						});
						if (!res.ok) throw new Error('Failed to fetch organization members');
						return await res.json();
					}
				: skipToken,
			staleTime: 1000 * 60,
		}),

	invitations: (organizationId: string) =>
		queryOptions({
			queryKey: [...orgQueries.all(), organizationId, 'invitations'],
			queryFn: async () => {
				const res = await api.orgs[':orgId'].invitations.$get({
					param: { orgId: organizationId },
				});
				if (!res.ok) throw new Error('Failed to fetch organization invitations');
				return await res.json();
			},
			staleTime: 1000 * 60,
		}),

	permissions: (organizationId: string) =>
		queryOptions({
			queryKey: [...orgQueries.all(), organizationId, 'permissions'],
			queryFn: async () => {
				const res = await api.orgs[':orgId'].permissions.$get({
					param: { orgId: organizationId },
				});
				if (!res.ok) return null;
				return await res.json();
			},
			staleTime: 1000 * 30,
		}),
};
